<template>
    <div v-if="!task" v-html="require(`./assets/svg/${name}.svg`)"></div>
    <div v-else v-html="createSvg()"></div>
</template>

<script>
export default {
  name: 'icon',
  props: ['name', 'task', 'goalColor', 'phaseCode', 'taskCode'],
  methods: {
    createSvg () {
      return require(`./assets/svg/tasks/task${this.name}.svg`).replace('%code%', `${this.phaseCode}-${this.taskCode}`)
    }
  }
}
</script>
